import { Component, OnInit, Inject, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import {
  User,
  UserResult,
  UsersFunc,
  RoleResult,
  RolesFunc,
  HealthcareProviderFunc,
  HealthcareProvider,
  LoginUser
} from '../services/webapiclient.service';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';

import messagesHu from 'node_modules/devextreme/localization/messages/hu.json';
import { formatMessage, loadMessages, locale } from 'devextreme/localization';

import { ErrorService } from '../services/error.service';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import CustomStore from 'devextreme/data/custom_store';
import { LoggingService } from '../services/logging.service';
import { AuthenticationService } from '../services/authentication.service';
import { Role } from '../models/role';
import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CouponGen } from '../module-subscription/subscription-models';
import { SubscriptionService } from '../module-subscription/subscription-service';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import notify from 'devextreme/ui/notify';

/**
 * Felhasználók kezelése (admin joggal).
 * SysAdmin csak sys vagy praxis adminokat tud felvenni.
 * Praxis admin az adott praxishoz tartozó orvosokat tud felvenni.
 */

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: false
})
export class UserComponent implements OnInit, OnDestroy {

  @ViewChild('generateCoupons', { static: true }) generateCoupons: TemplateRef<any>;

  userResult: UserResult = {} as UserResult;
  roleResult: RoleResult = {} as RoleResult;
  healthcareProviders: HealthcareProvider[] = {} as HealthcareProvider[];
  error: string;
  baseUri: string = `${environment.apiUrl}`;
  dataSource: any;
  rolesData: any;
  providersData: any;
  currentUser: LoginUser;
  sysAdmin: boolean;
  sendMailSuccess: boolean;
  selectedDoctorId: string;
  couponNumber: number;
  prefix: string;
  modalRef: BsModalRef;
  stylingMode = "filled";
  loading = false;
  couponGen = <CouponGen>{};
  displayName: string;
  private translSubs$: Subscription;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private usersFunc: UsersFunc,
    private rolesFunc: RolesFunc,
    private errorService: ErrorService,
    private authenticationService: AuthenticationService,
    private translation: L10nTranslationService,
    private healthcareProviderFunc: HealthcareProviderFunc,
    private modalService: BsModalService,
    private subscriptionService: SubscriptionService,
    private log: LoggingService
  ) {
    const huMessages = JSON.stringify(messagesHu['hu']);
    loadMessages({
      'hu': JSON.parse(huMessages)
    });

    // this.dataSource = new CustomStore({
    //   key: "id",
    //   load: () => this.getAll(),
    //   insert: (values) => this.insert(JSON.stringify(values)),
    //   update: (key, values) => this.update(key, JSON.stringify(values)),
    //   remove: (key) => this.delete(key).then()
    // });

    //Felhasználók
    // this.dataSource = AspNetData.createStore({
    //   key: 'Id',
    //   loadUrl: `${environment.apiUrl}UsersFunc/GetAllUsersAdm`,
    //   updateUrl: `${environment.apiUrl}UsersFunc/Update`,
    //   onBeforeSend(method, ajaxOptions) {
    //     ajaxOptions.xhrFields = { withCredentials: true };
    //     ajaxOptions.headers = {
    //       "Content-type": "application/json",
    //       "Authorization": `Bearer ${this.authenticationService.currentUserValue.token}`
    //     };
    //   },
    // });

    //Szerepkörök
    this.rolesData = new CustomStore({
      key: "id",
      loadMode: "raw",
      load: () => this.getRoles()
    });

    //Szolgáltatók
    this.providersData = new CustomStore({
      key: "id",
      loadMode: "raw",
      load: () => this.getProviders()
    });

  }


  ngOnInit(): void {
    this.translSubs$ = this.translation.onChange().subscribe(
      x => {
        locale(x.language);
      });
    this.currentUser = this.authenticationService.currentUserValue;
    this.sysAdmin = this.currentUser.role == Role.SysAdmin;

    //Felhasználók
    const that = this;
    this.dataSource = AspNetData.createStore({
      key: 'Id',
      loadUrl: `${environment.apiUrl}UsersFunc/GetAllUsersAdm`,
      updateUrl: `${environment.apiUrl}UsersFunc/Update`,
      insertUrl: `${environment.apiUrl}UsersFunc/Insert`,
      deleteUrl: `${environment.apiUrl}UsersFunc/Delete`,
      onBeforeSend(method, ajaxOptions) {
        //ajaxOptions.xhrFields = { withCredentials: true };
        // ajaxOptions.headers = {
        //   "Authorization": `Bearer ${that.currentUser.token}`
        // };
      },
    });

  }

  ngOnDestroy() {
    if (this.translSubs$) {
      this.translSubs$.unsubscribe();
    }
  }
  closeModal() {
    this.modalRef.hide();
  }

  isSendingMailIconVisible(e) {
    return e.row.data.CreatedOn == null;
  }

  onSendingMailIconClick = (e) => {
    this.loading = true;
    const userId = e.row.key;
    this.usersFunc.sendConfirmationEmailAgain(userId).subscribe(
      ret => {
        if (ret.result) {
          this.loading = false;
          notify({
            message: "Sikeres levélküldés!",
            position: {
              my: "center top",
              at: "center top"
            }
          }, "success", 3000);

        } else {
          this.error = ret.error;
          notify({
            message: "Levélküldési hiba!",
            position: {
              my: "center top",
              at: "center top"
            }
          }, "error", 3000);
        }
        this.loading = false;
      }
    );

    //e.event.preventDefault();
  }

  isGenerateCouponsIconVisible(e) {
    return e.row.data.Role == 'GP';
  }

  onGenerateCouponsIconClick = (e) => {
    this.displayName = e.row.data.DisplayName;
    this.selectedDoctorId = e.row.key;
    this.couponNumber = 20;
    this.prefix = this.getInitials(this.displayName);

    this.modalRef = this.modalService.show(this.generateCoupons, { class: 'modal-sm', backdrop: 'static', keyboard: false });
    e.event.preventDefault();
  };

  couponGeneration() {
    this.error = "";
    this.loading = true;
    this.couponGen.couponCount = this.couponNumber;
    this.couponGen.doctorId = this.selectedDoctorId;
    this.couponGen.prefix = this.prefix;

    this.subscriptionService.generateCouponsGP(this.couponGen).subscribe(
      result => {
        if (result.status == 200) {
          let fileURL = URL.createObjectURL(result.body);
          this.loading = false;
          this.closeModal();

          let downloadLink = document.createElement('a');
          downloadLink.href = fileURL;
          downloadLink.setAttribute('download', this.displayName + '-coupons.xlsx');
          document.body.appendChild(downloadLink);
          downloadLink.click();
          downloadLink.remove();

          //window.open(fileURL, "_blank", 'noreferrer');
        } else {
          this.error = result.body.toString();
        }
        this.loading = false;
      }
    );

  }

  getInitials(nameString) {
    let initials = '';
    const fullName = nameString.split(' ');
    if (fullName.length == 3) fullName.shift();
    if (fullName.length == 2) {
      initials = fullName[0].charAt(0) + fullName[1].charAt(0);
    } else {
      initials = fullName[0].charAt(0) + fullName[0].charAt(1);
    }
    return initials.toUpperCase();
  }

  getRoles() {
    return new Promise((resolve, reject) => {
      this.rolesFunc.getAll().pipe(first()).subscribe({
        next: (v) => this.roleResult = v,
        error: (e) => reject(e),
        complete: () => {
          if (this.roleResult.error === null) {
            for (let role of this.roleResult.roles) {
              role.translation = this.translation.translate('Role.' + role.name);
            }
            resolve(this.roleResult.roles);
          } else {
            //this.errorService.changeErrorMessage(this.roleResult.error);
            reject(this.roleResult.error);
          }
        }
      })
    });
  }

  getProviders() {
    return new Promise((resolve, reject) => {
      this.healthcareProviderFunc.getAll().pipe(first()).subscribe({
        next: (v) => this.healthcareProviders = v,
        error: (e) => reject(e.message),
        complete: () => resolve(this.healthcareProviders)
      })
    });

  }

  // getAll() {
  //   return new Promise((resolve, reject) => {
  //     this.usersFunc.getAll().pipe(first()).subscribe(
  //       (p) => {
  //         this.userResult = p;
  //       },
  //       (e) => {
  //         this.errorService.changeErrorMessage(e.message + ' - ' + e.error.ExceptionMessage);
  //         reject(e.message + e.error.ExceptionMessage);
  //       },
  //       () => {
  //         if (this.userResult.error === null) {
  //           resolve(this.userResult.users);
  //         } else {
  //           this.errorService.changeErrorMessage(this.userResult.error);
  //           reject(this.userResult.error);
  //         }
  //       }
  //     );
  //   });
  // }

  // insert(values: string) {
  //   let result: any;
  //   return new Promise((resolve, reject) => {
  //     this.usersFunc.insert(values).pipe(first()).subscribe(
  //       (p) => {
  //         result = p;
  //       },
  //       (e) => {
  //         this.errorService.changeErrorMessage(e);
  //         reject(e);
  //       },
  //       () => {
  //         if (result.succeeded) {
  //           resolve("OK");
  //         } else {
  //           //reject(result.errors[0].description);
  //           reject(this.translation.translate('Core.' + result.errors[0].code));
  //         }
  //       }
  //     );
  //   });
  // }

  // update(key: string, values: string) {
  //   let result: any;
  //   return new Promise((resolve, reject) => {
  //     this.usersFunc.update(key, values).pipe(first()).subscribe(
  //       (p) => {
  //         result = p;
  //       },
  //       (e) => {
  //         this.errorService.changeErrorMessage(e);
  //         reject(e);
  //       },
  //       () => {
  //         if (result.succeeded) {
  //           resolve("OK");
  //         } else {
  //           reject(this.translation.translate('Core.' + result.errors[0].code));
  //         }
  //       }
  //     );
  //   });
  // }

  // delete(key: string) {
  //   let result: any;
  //   return new Promise((resolve, reject) => {
  //     this.usersFunc.delete(key).pipe(first()).subscribe(
  //       (p) => {
  //         result = p;
  //       },
  //       (e) => {
  //         this.errorService.changeErrorMessage(e);
  //         reject(e);
  //       },
  //       () => {
  //         if (result.succeeded) {
  //           resolve("OK");
  //         } else {
  //           reject(this.translation.translate('Core.ErrorMessage_DeleteNotPossible'));
  //         }
  //       }
  //     );
  //   });
  // }
}
